// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"726bbe0d","228":"c3276b4f","451":"ca52a259"}[chunkId] + ".chunk.css";
};